import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import Field from '../../../../../../components/Form/Field'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'
import FileDetailsPreview from '../../../../../../components/FileDetailsPreview'
import DropFileUploader from '../../../../../../components/Form/DropFileUploader'

import useFileUpload from '../../../../../../features/hooks/useFileUpload'

import { fileUpload } from '../../../../../../modules/actions/files'

import { fileTypes } from '../../../../../../pages/Partnerships/PartnershipRightsList/helpers'
import { FILE_TYPE } from '../fields'

function RightFileUpload({ formik, onFileUploaded, error, availableFileTypesList }) {
  const dispatch = useDispatch()

  const { selectedFile, setSelectedFile, isFileLoading, fileUploadProgress } = useFileUpload({
    onFileUploaded
  })

  const handleFileChange = useCallback(
    file => {
      dispatch(
        fileUpload(file, {
          isPrivate: true
        })
      )
      setSelectedFile(file)
    },
    [dispatch, setSelectedFile]
  )

  const fileType = formik.values[FILE_TYPE]
  const fileTypeDetails = fileTypes[fileType]
  const IconImage = fileTypeDetails.icon

  return (
    <>
      {isFileLoading ? (
        <FileDetailsPreview
          key={selectedFile.name}
          fileName={selectedFile.name}
          isFileLoading={isFileLoading}
          fileUploadProgress={fileUploadProgress}
          fileUrl={selectedFile.path}
          FileIcon={IconImage}
          iconColor={fileTypeDetails['color']}
        />
      ) : (
        <>
          <Field formik={formik} name={FILE_TYPE} placeholder="File type" options={availableFileTypesList} />
          <DropFileUploader uploadText="Drag and drop your file, or click here" onUpload={handleFileChange} />
          {error && <ErrorMessage error={error} />}
        </>
      )}
    </>
  )
}

export default RightFileUpload
